import {createContext} from "react";


const LangContext = createContext({
  lang:'en',
  setLang:(lang) => {}
});
const CatsFilterContext = createContext({
  catsFilter:[],
  setCatsFilter:(cats) => {}
});
const CurrentPointContext = createContext({
  currentPoint:null,
  setCurrentPoint:(point) => {}
});

export {LangContext, CatsFilterContext, CurrentPointContext};